import Cookies from 'js-cookie';

// Cookie configuration for security
const COOKIE_OPTIONS = {
  secure: true,        // Only send over HTTPS
  sameSite: 'strict',  // CSRF protection
  expires: 1,          // 1 day expiration
  path: '/',           // Available site-wide
};

// Sensitive data cookie options (shorter expiration for tokens)
const SENSITIVE_COOKIE_OPTIONS = {
  secure: true,        // Only send over HTTPS
  sameSite: 'strict',  // CSRF protection
  expires: 1,       // 1 DAY expiration for tokens
  path: '/',           // Available site-wide
};

/**
 * Set a secure cookie for sensitive data (tokens)
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 */
export const setSecureCookie = (name, value) => {
  try {
    Cookies.set(name, value, SENSITIVE_COOKIE_OPTIONS);
  } catch (error) {
    console.error(`Error setting secure cookie ${name}:`, error);
  }
};

/**
 * Set a regular secure cookie
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 */
export const setCookie = (name, value) => {
  try {
    Cookies.set(name, value, COOKIE_OPTIONS);
  } catch (error) {
    console.error(`Error setting cookie ${name}:`, error);
  }
};

/**
 * Get a cookie value
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
export const getCookie = (name) => {
  try {
    return Cookies.get(name) || null;
  } catch (error) {
    console.error(`Error getting cookie ${name}:`, error);
    return null;
  }
};

/**
 * Remove a cookie
 * @param {string} name - Cookie name
 */
export const removeCookie = (name) => {
  try {
    Cookies.remove(name, { path: '/' });
  } catch (error) {
    console.error(`Error removing cookie ${name}:`, error);
  }
};

/**
 * Clear all authentication cookies
 */
export const clearAuthCookies = () => {
  const authCookies = ['access_token', 'ws_token', 'client_id', 'user_id', 'login_date', 'broker', 'name', 'auth_code'];
  authCookies.forEach(cookieName => {
    removeCookie(cookieName);
  });
};

/**
 * Check if user is authenticated based on cookies
 * @returns {boolean} - True if user has valid auth cookies
 */
export const isAuthenticated = () => {
  const accessToken = getCookie('access_token');
  const userId = getCookie('user_id');
  const loginDate = getCookie('login_date');
  const currentDate = new Date().toLocaleDateString();
  
  return !!(accessToken && userId && loginDate === currentDate);
};
 